import axios from "axios";
// import dayjs from "dayjs";
import { AuthData } from "../Components/Global";

const baseURL = process.env.REACT_APP_BASEURL;
// const Auth = AuthData();
// const userAccountId =
//     Auth &&
//         (Auth.Role === "user" || Auth.Role === "User") ?
//         Auth?.AccountId : ''

// const awalTahun = dayjs().startOf('year').format('YYYY-MM-DD');
// const akhirTahun = dayjs().endOf('year').format('YYYY-MM-DD');

export const GetTran = async () => {
  const response = await axios.get(`${baseURL}/get/tran`);

  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetOrders = async (AccountId, OrderCode) => {
  const response = await axios.get(
    `${baseURL}/get/all/orders${AccountId ? `?AccountId=${AccountId}` : ""}${OrderCode ? `&OrderCode=${OrderCode}` : ""
    }`
  );

  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetSPOrders = async (OrderCode, StartDate, EndDate) => {
  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;
  const CustomerId = Auth && Auth.Role === "Admin" ? "" : Auth.CustomerId;
  const response = await axios.get(
    `${baseURL}/get/sp/orders?AccountId=${AccountId}&OrderCode=${OrderCode}&StartDate=${StartDate}&EndDate=${EndDate}&CustomerId=${CustomerId}`
  );

  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetSPOrderDetail = async (AccountId, OrderCode) => {
  // const Auth = AuthData();
  // const AccountId = Auth.Role === "User" ? Auth.AccountId : '';
  const response = await axios.get(
    `${baseURL}/get/sp/order/detail?AccountId=${AccountId}&OrderCode=${OrderCode}`
  );

  return response.data;
};

export const GetSamples = async (AccountId, OrderCode, CustomerId) => {
  const response = await axios.get(
    `${baseURL}/get/all/samples?AccountId=${AccountId}&OrderCode=${OrderCode}&CustomerId=${CustomerId}`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetSPSamples = async (SampleCode, StartDate, EndDate) => {
  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;
  const CustomerId = Auth && Auth.Role === "Admin" ? "" : Auth.CustomerId;
  const response = await axios.get(
    `${baseURL}/get/sp/samples?AccountId=${AccountId}&SampleCode=${SampleCode}&StartDate=${StartDate}&EndDate=${EndDate}&CustomerId=${CustomerId}`
  );

  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetSPSampleDetail = async (AccountId, SampleCode) => {
  const response = await axios.get(
    `${baseURL}/get/sp/sample/detail?AccountId=${AccountId}&SampleCode=${SampleCode}`
  );
  return response.data;
};

export const GetCustomers = async (CustomerId) => {
  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/all/customers?AccountId=${AccountId}${CustomerId ? `&CustomerId=${CustomerId}` : ""
    }`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetCustomerJoin = async (CustomerId) => {
  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/all/customer/join?AccountId=${AccountId}${CustomerId ? `&CustomerId=${CustomerId}` : ""
    }`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetSPCustomer = async (CustomerId) => {
  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/sp/customer?AccountId=${AccountId}&CustomerId=${CustomerId}`
  );
  return response.data;
};

export const GetAllCOA = async (AccountId, COACode) => {
  const response = await axios.get(
    `${baseURL}/get/all/coa${AccountId
      ? `?AccountId=${AccountId}${COACode ? `&COACode=${COACode}` : ""}`
      : ""
    }`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetAllCOASample = async (AccountId, COACode) => {
  const response = await axios.get(
    `${baseURL}/get/sp/all/coa/sample?AccountId=${AccountId}&COACode=${COACode}`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetSPCOA = async (COACode, StartDate, EndDate) => {
  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;
  const CustomerId = Auth && Auth.Role === "Admin" ? "" : Auth.CustomerId;
  const response = await axios.get(
    `${baseURL}/get/sp/coa?AccountId=${AccountId}&COACode=${COACode}&StartDate=${StartDate}&EndDate=${EndDate}&CustomerId=${CustomerId}`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetSPCOADetail = async (AccountId, COACode) => {
  const response = await axios.get(
    `${baseURL}/get/sp/coa/detail?AccountId=${AccountId}&COACode=${COACode}`
  );
  return response.data;
};

export const GetSPCOASample = async (RFNumber, ReportNumber) => {
  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/sp/coa/sample?AccountId=${AccountId}&RFNumber=${RFNumber}${ReportNumber ? `&ReportNumber=${ReportNumber}` : ''}`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetSPCOAOrder = async (AccountId) => {
  const response = await axios.get(
    `${baseURL}/get/sp/coa/order?AccountId=${AccountId}`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

// export const GetSPAll_COASample = async (COACode) => {
//   const Auth = AuthData();
//   const AccountId = Auth?.AccountId;
//   const response = await axios.get(
//     `${baseURL}/get/sp/coa/order?AccountId=${AccountId}&COACode=${COACode}`
//   );
//   return response.data.map((row, index) => ({ ...row, key: index + 1 }));
// };

export const GetAllSales = async (AccountId, SalesCode) => {
  const response = await axios.get(
    `${baseURL}/get/all/sales${AccountId ? `?AccountId=${AccountId}` : ""}${SalesCode ? `&SalesCode=${SalesCode}` : ""
    }`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetAllParameterMain = async (ParameterCode) => {
  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/all/parametermain?AccountId=${AccountId}${ParameterCode ? `&ParameterCode${ParameterCode}` : ""
    }`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetAllinvoice = async () => {
  const response = await axios.get(`${baseURL}/get/all/invoice`);
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetSPInvoice = async (InvoiceCode, StartDate, EndDate) => {
  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;
  const CustomerId = Auth && Auth.Role === "Admin" ? "" : Auth.CustomerId;
  const response = await axios.get(
    `${baseURL}/get/sp/invoice?AccountId=${AccountId}&InvoiceCode=${InvoiceCode}&StartDate=${StartDate}&EndDate=${EndDate}&CustomerId=${CustomerId}`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetSPInvoiceDetail = async (AccountId, InvoiceCode) => {
  const response = await axios.get(
    `${baseURL}/get/sp/invoice/detail?AccountId=${AccountId}&InvoiceCode=${InvoiceCode}`
  );
  return response.data;
};

export const GetSPInvoiceRFNumber = async (OrderCode) => {
  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/sp/invoice/rfnumber?AccountId=${AccountId}&OrderCode=${OrderCode}`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetSPInvoiceOrder = async () => {
  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/sp/invoice/order?AccountId=${AccountId}`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetAllDocument = async (AccountId, RefNo) => {
  // const Auth = AuthData();
  // const AccountId = Auth && Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/all/document?AccountId=${AccountId}&RefNo=${RefNo}`
  );
  return response.data.map((row, index) => ({ ...row, key: index + 1 }));
};

export const GetAllAdminAccount = async () => {
  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/all/admin?AccountId=${AccountId}`
  );
  return response.data.map((item, index) => ({ ...item, key: index + 1 }));
};

export const GetAllNews = async () => {
  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/all/news?AccountId=${AccountId}`
  );
  return response.data.map((item, index) => ({ ...item, key: index + 1 }));
};

export const GetMessageFilter = async (AccountId, CustomerId) => {
  const response = await axios.get(
    `${baseURL}/get/message/filter?AccountId=${AccountId}&CustomerId=${CustomerId}`
  );
  return response.data;
};

export const GetChats = async () => {
  const response = await axios.get(`${baseURL}/get/chat`);
  return response.data;
};

export const GetSalesMonthGrowth = async (CustomerId, Date) => {
  const Auth = AuthData();
  const AccountId = Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/analytic/SalesMonthGrowth?AccountId=${AccountId}&CustomerId=${CustomerId}&Date=${Date}`
  );
  return response.data;
};

export const GetSalesYTD = async (CustomerId, Date) => {
  const Auth = AuthData();
  const AccountId = Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/analytic/SalesYTD?AccountId=${AccountId}&CustomerId=${CustomerId}&Date=${Date}`
  );
  return response.data;
};

export const GetTOPYearSales = async (CustomerId, Date) => {
  const Auth = AuthData();
  const AccountId = Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/analytic/TOPYearSales?AccountId=${AccountId}&CustomerId=${CustomerId}&Date=${Date}`
  );
  return response.data;
};

export const GetSPProfile = async (CustomerId) => {
  const Auth = AuthData();
  const AccountId = Auth.AccountId;
  const response = await axios.get(
    `${baseURL}/get/sp/profile?AccountId=${AccountId}&CustomerId=${CustomerId}`
  );
  return response.data;
};

export const GetSPDashboard = async () => {
  const Auth = AuthData();
  const AccountId = Auth?.AccountId;
  const CustomerId = Auth && Auth.Role === "Admin" ? "" : Auth.CustomerId;
  const response = await axios.get(
    `${baseURL}/get/sp/dashboard?AccountId=${AccountId}&CustomerId=${CustomerId}`
  );
  return response.data;
};

export const GetSPTestingCost = async (StartDate, EndDate, customer_id) => {
  const Auth = AuthData();
  const AccountId = Auth.AccountId;
  let url = `${baseURL}/get/sp/testingcost?AccountId=${AccountId}&StartDate=${StartDate}&EndDate=${EndDate}`;

  if (customer_id) {
    url += `&CustomerId=${customer_id}`;
  }

  const response = await axios.get(url);
  return response.data;
};

export const GetSPTestingCostBySalesCode = async (
  StartDate,
  EndDate,
  sales_code
) => {
  const Auth = AuthData();
  const AccountId = Auth.AccountId;

  let url = `${baseURL}/get/sp/testingcost/sales?AccountId=${AccountId}&StartDate=${StartDate}&EndDate=${EndDate}`;

  if (sales_code) {
    url += `&SalesCode=${sales_code}`;
  }

  const response = await axios.get(url);
  return response.data;
};

export const GetSPTestingCostByDepartment = async (
  StartDate,
  EndDate,
  department
) => {
  const Auth = AuthData();
  const AccountId = Auth.AccountId;

  let url = `${baseURL}/get/sp/testingcost/department?AccountId=${AccountId}&StartDate=${StartDate}&EndDate=${EndDate}`;

  if (department) {
    url += `&Deparment=${department}`;
  }

  const response = await axios.get(url);
  return response.data;
};

export const GetSPTestingCostByLabSubCount = async (
  StartDate,
  EndDate,
  labsubcount
) => {
  const Auth = AuthData();
  const AccountId = Auth.AccountId;

  let url = `${baseURL}/get/sp/testingcost/labsubcont?AccountId=${AccountId}&StartDate=${StartDate}&EndDate=${EndDate}`;

  if (labsubcount) {
    url += `&Labsubcont=${labsubcount}`;
  }

  const response = await axios.get(url);
  return response.data;
};

// // OLD
// export const getOrderView = async (Date1, Date2, OrderCode) => {
//     const Auth = AuthData();
//     const accountId = Auth && Auth?.AccountId;
//     const response = await axios.get(
//         `${baseURL}/dashboard/get/order_view?AccountId=${accountId}&OrderCode=${OrderCode ? OrderCode : ''}&Date1=${Date1}&Date2=${Date2}`
//     );

//     // Mengurutkan hasil berdasarkan OrderCode secara descending (DESC)
//     const sortedData = response.data.sort((a, b) => b.OrderCode.localeCompare(a.OrderCode));

//     return sortedData.map((row, index) => ({ ...row, key: index + 1 }));
// };

// export const getOrder = async (AccountId, OrderCode) => {
//     const response = await axios.get(`${baseURL}/dashboard/get/order/detail?AccountId=${AccountId}&OrderCode=${OrderCode}`)
//     return response.data.map((row, index) => ({ ...row, key: index + 1 }))
// }

// export const getOrders = async () => {
//     const response = await axios.get(`${baseURL}/dashboard/get/orders`);
//     const sortedData = response.data.sort((a, b) => a.OrderCode.localeCompare(b.OrderCode));
//     return sortedData.map((row, index) => ({ ...row, key: index + 1 }));
// }

// // GET SAMPLE
// export const getSampleView = async (Date1, Date2) => {
//     const Auth = AuthData();
//     const accountId = Auth.Role === "User" ? Auth?.AccountId : ''
//     const response = await axios.get(`${baseURL}/dashboard/get/sample_view?AccountId=${accountId}&SampleCode=&Date1=${Date1}&Date2=${Date2}`)
//     return response.data.map((row, index) => ({ ...row, key: index + 1 }))
// }

// export const getSample = async (AccountId, SampleCode) => {
//     const response = await axios.get(`${baseURL}/dashboard/get/sample?AccountId=${AccountId}&SampleCode=${SampleCode}`)
//     return response.data
// }

// export const getSamples = async (AccountId, SampleCode) => {
//     const response = await axios.get(`${baseURL}/dashboard/get/samples${AccountId ? `?AccountId=${AccountId}` : ''}${SampleCode ? `&SampleCode=${SampleCode}` : ''} `)
//     return response.data;
// }

// // GET COA
// export const getCOAView = async (Date1, Date2) => {
//     const Auth = AuthData();
//     const accountId = Auth.Role === "User" ? Auth?.AccountId : ''
//     const response = await axios.get(`${baseURL}/dashboard/get/coa_view?AccountId=${accountId}&COACode=&Date1=${Date1}&Date2=${Date2}`)
//     return response.data.map((row, index) => ({ ...row, key: index + 1 }))
// }

// // GET CUSTOMER
// export const getCustomerDetail = async (AccountId) => {
//     const response = await axios.get(`${baseURL}/dashboard/get/customer/detail${AccountId ? `?AccountId=${AccountId}` : ''}`);
//     return response.data.map((row, index) => ({ ...row, key: index + 1 }));
// }

// export const getCustomers = async () => {
//     const response = await axios.get(`${baseURL}/dashboard/get/customers`);
//     return response.data.map((row, index) => ({ ...row, key: index + 1 }));
// }

// // GET INVOICE
// export const getInvoiceView = async (Date1, Date2) => {
//     const Auth = AuthData();
//     const accountId = Auth.Role === "User" ? Auth?.AccountId : ''
//     const response = await axios.get(`${baseURL}/dashboard/get/invoice_view?AccountId=${accountId}&InvoiceNo=&Date1=${Date1}&Date2=${Date2}`)
//     const sortedData = response.data.sort((a, b) => a.InvoiceNo.localeCompare(b.InvoiceNo));

//     return sortedData.map((row, index) => ({ ...row, key: index + 1 }));
// }

// export const getInvoice = async (AccountId, InvoiceNo) => {
//     const response = await axios.get(`${baseURL}/dashboard/get/invoice?AccountId=${AccountId}&InvoiceNo=${InvoiceNo}`)
//     return response.data.map((row, index) => ({ ...row, key: index + 1 }))
// }

// export const getInvoices = async () => {
//     const response = await axios.get(`${baseURL}/dashboard/get/invoices`);
//     const sortedData = response.data.sort((a, b) => a.InvoiceNo.localeCompare(b.InvoiceNo));
//     return sortedData
// }

// export const getOrderDocs = async (AccountId, OrderCode) => {
//     const response = await axios.get(`${baseURL}/dashboard/get/order/docs?AccountId=${AccountId}&OrderCode=${OrderCode}`);
//     return response.data;
// }

// export const getCustomerAccount = async () => {
//     const response = await axios.get(`${baseURL}/dashboard/get/customer_account`);
//     return response.data.map((row, index) => ({ ...row, key: index + 1 }));
// }

// export const getAccountAdmin = async () => {
//     const response = await axios.get(`${baseURL}/dashboard/get/account_admin`);
//     return response.data.map((row, index) => ({ ...row, key: index + 1 }));
// }

// export const getNews = async () => {
//     const response = await axios.get(`${baseURL}/dashboard/get/news`);
//     return response.data.map((row, index) => ({ ...row, key: index + 1 }));
// }

// export const getUsers = async () => {
//     const response = await axios.get(`${baseURL}/dashboard/get/users`);
//     return response.data.map((row, index) => ({ ...row, key: index + 1 }));
// }
